export class NotLoggedInError extends Error {
  constructor() {
    super('User is not logged in');
    this.name = 'NotLoggedInError';
  }
}

export const isNotLoggedInError = (
  error: unknown
): error is NotLoggedInError => {
  return error instanceof NotLoggedInError && error.name === 'NotLoggedInError';
};

export class MissingTokenError extends Error {
  constructor() {
    super('No token found in storage');
    this.name = 'MissingTokenError';
  }
}

export const isMissingTokenError = (
  error: unknown
): error is MissingTokenError => {
  return (
    error instanceof MissingTokenError && error.name === 'MissingTokenError'
  );
};

export class GetTokenError extends Error {
  constructor() {
    super('Error getting access token');
    this.name = 'GetTokenError';
  }
}

export class TokenDecodeError extends Error {
  constructor() {
    super('Error decoding token');
    this.name = 'TokenDecodeError';
  }
}
